// @flow

import { type LookAndFeel } from '@tectonics/look-and-feel';

const shopify: LookAndFeel = {
  code: 'shopify',
  displayName: 'Shopify',
  getRootComponent: () => import('./shopify'),
  getLoadingPage: () => import('@tectonics/components/loading-page'),
  prsSupport: {
    integrations: {
      br: ['creditcard', 'boleto', 'pix'],
      mx: ['creditcard', 'debitcard', 'oxxo', 'spei'],
      co: ['baloto', 'eft', 'creditcard', 'ewallet'],
      ar: ['creditcard', 'debitcard', 'cash'],
      pe: ['creditcard'],
      cl: ['webpay', 'multicaja', 'servipag', 'sencillito'],
      ec: ['safetypay-cash', 'safetypay-online'],
      bo: ['cash'],
      uy: ['creditcard', 'debitcard'],
    },
    features: [
      { name: 'field_customer_name' },
      { name: 'field_brazilian_document',
        traits: ['type_cpf'] },
      { name: 'field_colombian_document' },
      { name: 'field_colombian_document_type' },
      { name: 'field_customer_email' },
      { name: 'field_card_holder_name' },
      { name: 'field_card_number' },
      { name: 'field_card_expiry_date' },
      { name: 'field_card_security_code' },
      { name: 'field_card_instalments' },
      { name: 'field_accept_visa_terms' },
      { name: 'display_merchant_logo' },
      { name: 'display_receipt_original_amount' },
      { name: 'display_receipt_fx_rate' },
      { name: 'display_receipt_brazilian_tax_iof' },
      { name: 'display_receipt_final_amount' },
      { name: 'display_selected_instalment' },
      { name: 'field_brazilian_phone_number' },
      { name: 'field_brazilian_zipcode' },
      { name: 'field_mexican_phone_number' },
      { name: 'field_mexican_zipcode' },
      { name: 'field_colombian_phone_number'},
      { name: 'field_colombian_zipcode'},
      { name: 'field_mexican_phone_number' },
      { name: 'field_argentine_cash_bank_list', traits: ['cupon', 'pagofacil', 'rapipago'] },
      { name: 'field_argentine_document' },
      { name: 'field_argentine_document_type' },
      { name: 'field_argentine_phone_number' },
      { name: 'field_argentine_zipcode' },
      { name: 'field_ecuadorian_document'},
      { name: 'field_ecuadorian_phone_number'},
      { name: 'display_boleto_total_value' },
      { name: 'display_boleto_due_date' },
      { name: 'display_boleto_barcode' },
      { name: 'display_boleto_number' },
      { name: 'display_boleto_tips' },
      { name: 'action_boleto_copy_code' },
      { name: 'action_boleto_save_pdf' },
      { name: 'display_boleto_email_warning' },
      { name: 'display_cash_total_value' },
      { name: 'display_cash_due_date' },
      { name: 'display_cash_barcode' },
      { name: 'display_cash_number' },
      { name: 'action_cash_download' },
      { name: 'action_cash_save_pdf' },
      { name: 'display_cash_email_warning' },
      { name: 'display_cash_instructions' },
      { name: 'display_cash_tips' },
      { name: 'display_paynet_payment_locations' },
      {
        name: 'display_card_accepts_brand',
        traits: ['visa', 'mastercard', 'amex', 'carnet', 'diners', 'discover', 'elo', 'hipercard', 'naranja', 'credimas', 'cabal'],
      },
      {
        name: 'display_debit_card_accepts_brand',
        traits: ['visa', 'mastercard', 'amex', 'carnet', 'diners', 'discover', 'elo', 'hipercard'],
      },
      { name: 'display_baloto_mail_warning' },
      { name: 'display_baloto_total_value' },
      { name: 'display_baloto_due_date' },
      { name: 'display_baloto_payment_locations' },
      { name: 'action_baloto_save_pdf' },
      { name: 'display_baloto_tips' },
      { name: 'display_baloto_instructions' },
      { name: 'display_spei_mail_warning' },
      { name: 'display_spei_due_date' },
      { name: 'display_spei_total_amount' },
      { name: 'display_receipt_argentine_tax_ip'},
      { name: 'display_receipt_argentine_tax_ig_ibp'},
      { name: 'field_colombian_bank_list' },
      { name: 'field_peruvian_document' },
      { name: 'field_peruvian_zipcode' },
      { name: 'field_chilean_document' },
      { name: 'field_chilean_phone_number' },
      { name: 'field_captcha_token' },
      { name: 'field_bolivian_phone_number' },
      { name: 'display_pagosnet_instructions' },
      { name: 'display_pagosnet_email_warning' },
      { name: 'display_pagosnet_total_value' },
      { name: 'display_pagosnet_due_date' },
      { name: 'display_pagosnet_locations' },
      { name: 'action_pagosnet_save_pdf' },
      { name: 'action_pagosnet_print_instructions' },
      { name: 'display_safetypay_cash_banks' },
      { name: 'display_safetypay_online_banks' },
      { name: 'field_uruguayan_document' },
      { name: 'field_uruguayan_zipcode' },
    ],
  },
};

export default shopify;
